export const DropPositions = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  MIDDLE: 'MIDDLE'
};
export const DragTypes = {
  ADVANCED_MENUS_MENU_NODE: 'ADVANCED_MENUS_MENU_NODE'
};